import React, { useMemo } from 'react';
import { TaskySelect } from '../tasky';
import { TaapProductScope } from './useTaapProductScope';
import { PLATFORM_LABELS } from '../../utils/taapFormat';

interface Props {
  scope: TaapProductScope;
  onSelectProduct: (id: number) => void;
  onSelectAccount: (id: number | null) => void;
}

/**
 * 商品セレクタと、商品内のアカウントセレクタ。
 *
 * 組織全体の合算は出さないので「全アカウント」の選択肢は無い。アカウントの
 * セレクタは、その商品に2件以上紐付いているときだけ出す。
 */
const TaapScopePicker: React.FC<Props> = ({ scope, onSelectProduct, onSelectAccount }) => {
  const { products, productId, accountId, productAccounts } = scope;
  // 媒体が混ざっている商品でだけ媒体名を前置きする。
  const hasMultiplePlatforms = useMemo(
    () => new Set(productAccounts.map((account) => account.platform)).size > 1,
    [productAccounts],
  );

  if (productId === null) return null;

  return (
    <>
      <div className="w-[220px] max-w-full">
        <TaskySelect
          aria-label="商品"
          value={String(productId)}
          onChange={(event) => onSelectProduct(Number(event.target.value))}
          className="h-9 text-sm"
        >
          {products.map((product) => (
            <option key={product.id} value={product.id}>
              {product.name}
            </option>
          ))}
        </TaskySelect>
      </div>
      {productAccounts.length > 1 && (
        <div className="w-[220px] max-w-full">
          <TaskySelect
            aria-label="広告アカウントで絞り込む"
            value={accountId === null ? '' : String(accountId)}
            onChange={(event) => onSelectAccount(event.target.value === '' ? null : Number(event.target.value))}
            className="h-9 text-sm"
          >
            <option value="">すべて（{productAccounts.length}件）</option>
            {productAccounts.map((account) => {
              const name = account.account_name ?? `アカウント #${account.id}`;
              return (
                <option key={account.id} value={account.id}>
                  {hasMultiplePlatforms ? `${PLATFORM_LABELS[account.platform] ?? account.platform} / ${name}` : name}
                </option>
              );
            })}
          </TaskySelect>
        </div>
      )}
    </>
  );
};

export default TaapScopePicker;
